import styled from 'styled-components';
import { FlexibleTextPartial, colours, media } from '@storefront/lib-global';

export const CustomFlexibleTextPartial = styled(FlexibleTextPartial)`
  margin: 0;
`;

export const IconWrapper = styled.span<{ $isLocationIcon: boolean }>`
  align-items: center;
  display: flex;
  height: 25px;
  justify-content: center;
  width: 25px;

  & svg {
    transform: ${({ $isLocationIcon }) => ($isLocationIcon ? 'scale(1.5)' : 'scale(1.5625)')};
  }
  & svg path {
    fill: ${colours.BLACK};
  }
`;

export const LinkButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  display: inline-flex;
  font-size: 14px;
  font-weight: 600;
  gap: 4px;
  padding: 6px 0 0;
  text-decoration: underline;
  width: fit-content;

  @media ${media.greaterThan('lg')} {
    font-size: 16px;
  }
`;
